export default "__VITE_ASSET__DS5r46lb__"